<template>
  <div class="about_section">
    <div class="container my-2 pt-md-5">
      <base-row>
        <base-column :col="12" :colLg="6">
          <about-cover>
            <img src="../assets/images/me.png">
          </about-cover>
        </base-column>
        <base-column :col="12" :colLg="6">
          <div class="p-4"></div>
          <base-heading :wrapper=false :smallBottomMargin=true :type-array="['Know More', 'Who Am I']">
            <template v-slot:default>ABOUT ME</template>
          </base-heading>
          <base-paragraph>{{ aboutMe }}</base-paragraph>

            <a href="/assets/resume/CHAICHAA_Imad-CV.pdf" download>
              <button-primary>
                Download Resume
              </button-primary>
            </a>

        </base-column>
      </base-row>
    </div>
    <div>
      <base-row class="pb-2">
        <base-heading :smallBottomMargin=true :type-array="['Learning', 'Education']">
          <template v-slot:default>Education</template>
        </base-heading>
      </base-row>
      <timeline></timeline>
    </div>
    <div>
      <base-row>
        <base-heading :smallBottomMargin=true :type-array="['Projects', 'Involvement', 'Participation']">
          <template v-slot:default>EXPERIENCE</template>
          <template v-slot:sub>INVOLVEMENT</template>
        </base-heading>

          <div class="py-2"></div>

          <experience-cover v-for="experience in experiences.slice().reverse()" :key="experience.id">
            <template v-slot:year>{{ experience.year }}</template>
            <template v-slot:period>{{ experience.period }}</template>
            <template v-slot:function>{{ experience.function }}</template>
            <template v-slot:company>{{ experience.company }}</template>
            <template v-slot:description>{{ experience.description }}</template>
          </experience-cover>

      </base-row>
    </div>
  </div>
</template>

<script>

import AboutCover from "@/components/about/AboutCover";
import ExperienceCover from "@/components/about/ExperienceCover";
import Timeline from "@/components/about/timeline/Timeline";
import ButtonPrimary from "@/components/buttons/ButtonPrimary";


export default {
  components: {ButtonPrimary, Timeline, AboutCover,ExperienceCover},
  computed: {
    aboutMe() {
      return this.$store.getters['about/getAboutMe'];
    },
    experiences() {
      return this.$store.getters['about/getExperiences'];
    }
  }
}
</script>

<style scoped>
  .about_section {
    width: 100%;
    min-height: 100vh;
    background-color: white;
    padding-top: 3rem;
  }
</style>